module.exports = __webpack_public_path__ + "img/slider3.9032e62a.jpg";